import { apiClient } from './api.js';
import { unwrap } from './api-error.js';
import type { ApiPaths } from '@reos/api-client';

/**
 * Klient párování poptávek s nabídkami (krok CRM4, bod 2). Skóre a
 * vysvětlení („Sedí lokalita a cena, …") počítá server — jedna pravda
 * v `@reos/crm` `matching-rules.ts`; UI je jen ukazuje.
 */

type Json = 'application/json';

export type DemandMatch = NonNullable<
  ApiPaths['/v1/crm/properties/{id}/matches']['get']['responses']['200']['content'][Json]
>['items'][number];
export type NewMatches = NonNullable<ApiPaths['/v1/crm/matches/new']['get']['responses']['200']['content'][Json]>;
export type OfferPreview = NonNullable<
  ApiPaths['/v1/crm/offers/preview']['post']['responses']['200']['content'][Json]
>;

export async function listPropertyMatches(propertyId: string): Promise<DemandMatch[]> {
  const result = await unwrap(apiClient.GET('/v1/crm/properties/{id}/matches', { params: { path: { id: propertyId } } }));
  return result.items;
}

export async function listDemandMatches(demandId: string): Promise<DemandMatch[]> {
  const result = await unwrap(apiClient.GET('/v1/crm/demands/{id}/matches', { params: { path: { id: demandId } } }));
  return result.items;
}

export async function listNewMatches(limit = 3): Promise<NewMatches> {
  return unwrap(apiClient.GET('/v1/crm/matches/new', { params: { query: { limit } } }));
}

export async function recomputePropertyMatches(propertyId: string): Promise<void> {
  await unwrap(apiClient.POST('/v1/crm/matches/recompute', { body: { propertyId } }));
}

export async function dismissMatch(demandId: string, propertyId: string): Promise<void> {
  await unwrap(apiClient.POST('/v1/crm/matches/dismiss', { body: { demandId, propertyId } }));
}

export async function previewOffer(demandId: string, propertyId: string): Promise<OfferPreview> {
  return unwrap(apiClient.POST('/v1/crm/offers/preview', { body: { demandId, propertyId } }));
}

/** Odeslání JEN po náhledu — `confirmed: true` je výslovné potvrzení makléře. */
export async function sendOffer(demandId: string, propertyId: string): Promise<void> {
  await unwrap(apiClient.POST('/v1/crm/offers', { body: { demandId, propertyId, confirmed: true } }));
}
